import React, { useCallback, useEffect, useState } from "react";
import { Autocomplete, Value } from "@material-ui/lab";
import { useBoolean } from "../../hooks/utils/useBoolean";
import { Client } from "../../api/api";
import { useApi } from "../../hooks/useApi";
import { CircularProgress, TextField } from "@material-ui/core";

export interface AutocompleteClientsProps {
  value: Client | null
  onChange?: (c: Client|null) => void;
}

export const AutocompleteClients = (p: AutocompleteClientsProps) => {
  const { api, isAuth } = useApi();
  const [open, onOpen, onClose] = useBoolean(),
    [clients, setClients] = useState<Client[]>([]),
    [loading, lOn, lOff] = useBoolean(),
    [query, setQ] = useState("");

  useEffect(() => {
    if (isAuth) {
      lOn();
      (async () => {
        const res = await api.getClients({ query });
        if (res.status === 200) {
          setClients(res.body);
        }
      })().finally(lOff);
    }
  }, [api, isAuth, lOff, lOn, query]);

  const onChange = useCallback(
    (e: React.ChangeEvent<{}>, value: Value<Client, false, false, false>) => {
      if (p.onChange) {
        p.onChange(value);
      }
    },
    [p]
  );

  return (
    <Autocomplete<Client>
      onChange={onChange}
      value={p.value}
      open={open}
      onOpen={onOpen}
      onClose={onClose}
      loading={loading}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      options={clients}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Client"
          variant="outlined"
          value={query}
          onChange={(e) => setQ(e.target.value)}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};
